<template>
  <Container>
    <v-flex justify-start>
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title>Swipe Manager</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn icon color="green" v-on:click="toggleSelectCategory">
            <v-icon>add</v-icon>
          </v-btn>
          <v-text-field
            solo
            placeholder="Search"
            append-icon="search"
            hide-details
          ></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-list>
            <v-list-tile
              v-for="swipe in swipeStore.swipe"
              :key="swipe.category_id"
              v-on:click="() => onClickEdit(swipe.category_id)"
            >
              <v-list-tile-avatar>
                <v-icon>compare_arrows</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  >{{ swipe.category }} ({{
                    swipe.decks.length
                  }})</v-list-tile-title
                >
                <v-list-tile-sub-title
                  >Updated at {{ swipe.updated_at }}</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
    <Category
      :v-if="isSelectCategory"
      :isOpen="isSelectCategory"
      :close="toggleSelectCategory"
      :onSelect="onClickSelectCategory"
      :value="categoryId"
      title="Select Category"
    >
    </Category>
  </Container>
</template>
<script>
import Container from '../../components/Container';
import Category from '../../components/Category';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'SwipeList',
  components: {
    Container,
    Category,
  },
  data: function () {
    return {
      isSelectCategory: false,
      categoryId: '',
    };
  },
  methods: {
    ...mapActions('swipe', ['fetchSwipe', 'selectSwipe', 'selectCategory']),
    onClickEdit(id) {
      this.selectSwipe(id);
      this.selectCategory();
      this.$router.push({
        path: '/swipe/detail',
        query: {
          id,
        },
      });
    },
    toggleSelectCategory() {
      this.isSelectCategory = !this.isSelectCategory;
    },
    onClickSelectCategory(id) {
      this.isSelectCategory = false;
      this.selectCategory(id);
      this.selectSwipe();
      this.$router.push({
        path: '/swipe/detail',
        query: {
          id,
        },
      });
    },
  },
  mounted() {
    this.fetchSwipe({
      page: 1,
      limit: 0,
    });
  },
  computed: {
    ...mapState({
      swipeStore: state => state.swipe,
    }),
  },
};
</script>
